module.exports = __webpack_public_path__ + "static/media/img-download-center3.ed1ac8dd.png";